<template>
  <div>
    <div class="a-container-form u-border-1px-bottom a-flex-wrap u-padding-0">
      <div class="a-group-btn u-margin-b-0 u-width-615px u-padding-top-24px" >
        <p class="a-group-btn__text">{{$t('labels.actions')}}</p>

        <div class="a-group-btn">
          <p class="a-label u-margin-b-10">{{$t('form.lot.specification')}}:</p>
          <div class="a-group-btn__left">
            <!--          <button class="gui-btn gui-btn&#45;&#45;red gui-btn&#45;&#45;w-184">Настройка <br> таблицы</button>-->
            <button class="gui-btn gui-btn--red gui-btn--w-184"
                    v-if="currentUser.permissions.CAN_DOWNLOAD_REDUCTION_SPECIFICATION"
                    @click.prevent="onDownloadSpecificationTemplateClick">{{$t('buttons.download-xlsx-using-template')}}</button>
            <file-picker :accept="['xlsx', 'xls']"
                         :signing="false"
                         :label="'buttons.upload-from-template'"
                         @prepared="uploadSpecificationTemplate"
            >
            </file-picker>
            <!--          <button class="gui-btn gui-btn&#45;&#45;red gui-btn&#45;&#45;w-184">Сохранить <br> выделение</button>-->
          </div>
        </div>
      </div>
    </div>

    <upload-template ref="configureTemplate" @ready="completeSpecificationTemplate"></upload-template>

    <section v-maximizable>
    <div class="a-container-form a-width-100-percent">
      <div class="a-group-btn u-margin-top-24 u-margin-b-0 a-width-100-percent">
        <p class="a-group-btn__text">{{$t('form.lot.reduction-bid-filters')}}</p>
        <div class="a-flex-start a-flex-wrap a-align-items-center a-width-100-percent">
          <dropdown-new class="select-w-456"
                        v-model="method"
                        :placeholder="'form.lot.reduction-bid-filter.no-filters'">
            <option value :label="'form.lot.reduction-bid-filter.no-filters'"></option>
            <option :value="enums.ReductionSpecFilter.MY_BID" :label="'form.lot.reduction-bid-filter.included-to-my-bid'"></option>
            <option :value="enums.ReductionSpecFilter.NO_MY_BID" :label="'form.lot.reduction-bid-filter.included-to-none-of-my-bids'"></option>
            <option :value="enums.ReductionSpecFilter.LEADER" :label="'form.lot.reduction-bid-filter.my-bid-is-leader'"></option>
            <option :value="enums.ReductionSpecFilter.NOT_LEADER" :label="'form.lot.reduction-bid-filter.my-bid-is-not-leader'"></option>
          </dropdown-new>
        </div>
      </div>
    </div>

    <form class="a-sort u-border-1px-top u-padding-top-24px" action="">
      <p class="a-sort__see">
        {{$tc('form.lot.reduction-bid-filter.filtered-result', specs.length)}}
      </p>
    </form>

    <div class="a-container-form ">
      <div class="a-flex-start a-width-100-percent">
        <dropdown-new class="select-w-260 u-margin-right-20"
                      :placeholder="'form.lot.reduction-report.show-all'"
                      v-model="selectionMode" >
          <option value :label="'form.lot.reduction-report.show-all'"></option>
          <option value="ShowCheck" :label="'form.lot.reduction-report.show-selected'"></option>
          <option value="ShowUncheck" :label="'form.lot.reduction-report.hide-selected'"></option>
        </dropdown-new>
        <button class="gui-btn gui-btn--red  gui-btn--w-127" @click.prevent="onResetSelectionClick">{{$t('buttons.reset')}}</button>
      </div>
    </div>

    <div class="table-tab table-tab--media460-responsible table-tab--th-row-none u-padding-b-24">
      <div class="table-tab__container" tabindex="1" style="overflow: auto; outline: none">
        <table class="table-tab__block table" style="width: 2000px" v-columns-resizable>
          <thead class="table-tab__thead">
          <tr class="table-tab__tr">
            <th></th>
            <th class=" table-tab__th--row table-tab__border-right">№</th>

            <th>{{$t('form.lot.specs.nomenclature')}}</th>
            <!--<th>Производитель</th>-->
            <th>{{$t('form.lot.specs.quantity')}}</th>
            <th>{{$t('form.lot.specs.unit')}}</th>
            <th v-for="item in expertCriteria">
              {{item.criterionName}} ({{item.weight | percent}}%)
            </th>
            <th v-for="item in reductionCriteria">
              {{item.criterionName}} ({{item.weight | percent}}%)
            </th>
            <th tag="leader" v-if="canSeeLeaderBid"></th>
            <th>{{$t('form.lot.specs.present-price')}} ({{reducedPriceWeight | percent}}%)</th>
            <th>{{$t('form.lot.specs.total-price')}}</th>
            <th v-for="item in lotPriceCriteria">{{$t('form.lot.specs.my-bid-price-in-lot-currency')}}</th>
            <th v-for="(item, i) in priceCriteria"></th>
          </tr>
          </thead>
          <tbody class="table-tab__tbody">
            <template v-for="(row, rowId) in rows" >
              <tr class="table-tab__tr" :key="`spec-position-${row.position}`">
                <td :rowspan="canSeeLeaderBid ? 2 : 1">
                  <input type="checkbox" v-model="selection[row.position]"/>
                </td>
                <th class="table-tab__th--row table-tab__border-right" :rowspan="canSeeLeaderBid ? 2 : 1">
                  {{row.position}}
                </th>
                <td :rowspan="canSeeLeaderBid ? 2 : 1">
                  {{row.catalog.name}}
                </td>
                <!--<td>-->
                <!--{{row.vendor}}-->
                <!--</td>-->
                <td :rowspan="canSeeLeaderBid ? 2 : 1">
                  {{row.count}}
                </td>
                <td :rowspan="canSeeLeaderBid ? 2 : 1">
                  {{row.okeiName}}
                </td>

                <td v-for="item in expertCriteria" :rowspan="canSeeLeaderBid ? 2 : 1">
                  <template v-if="item.showFileInput">
                    <file-link :name="file.name"
                               :size="file.size"
                               :link="externalLink(file.uid)"
                               :removable="bid.permissions.CAN_EDIT_BID"
                               :key="file.uid"
                               :signed="file.hasSign"
                               @remove="onRemoveFileClick({ criterionId: item.num, fileId: file.num, position: row.position })"
                               v-for="file in row.criteria[item.id].files">
                    </file-link>

                    <template v-if="row.criteria[item.id].files.length === 0">
                      <file-picker @prepared="onFileReady($event, { criterionId: item.num, position: row.position })"
                                   mode="link"
                                   :signing="lot.permissions.SHOULD_BE_SIGNED"
                                   v-if="bid.permissions.CAN_EDIT_BID">
                      </file-picker>
                      <p class="a-input a-input--disabled" v-else>{{$t('labels.no-files')}}</p>
                    </template>
                  </template>

                  <template v-else>
                    <textarea class="a-input"
                           v-model="row.criteria[item.id].value"
                           rows="2"
                           @blur="saveForm()"
                           v-if="bid.permissions.CAN_EDIT_BID"></textarea>
                    <p v-else>{{row.criteria[item.id].value}}</p>
                  </template>

                  <template v-if="(lot.permissions.CAN_ESTIMATE_CRITERION_IN_PUBLIC_LOT || lot.permissions.CAN_SEE_PUBLIC_LOT_MY_REQUEST) && hasBidForPosition(row.position)">
                    <p>{{$t('labels.estimation')}}--</p>
                    <input-estimation class="a-input a-input--w-140"
                                      v-model="row.criteria[item.id].estimate"
                                      @blur="onSaveCriterionEstimation({ criterionId: item.num, estimation: row.criteria[item.id].estimate, position: row.position })"
                                      v-if="item.permissions.CAN_EDIT_CRITERIA_ESTIMATION">
                    </input-estimation>
                    <p v-else>{{row.criteria[item.id].estimate| estimation}}</p>
                  </template>
                </td>

                <td :class="{'table-tab__background--green':isMyBidBest(row.position)}"
                    :rowspan="canSeeLeaderBid ? 2 : 1"
                    v-for="item in reductionCriteria">
                  <p class="u-padding-bottom-12">{{item.criterionName}}:</p>

                  <template v-if="bid.permissions.CAN_EDIT_BID || (bid.isEditingForRetend && hasBidForPosition(row.position))">
                    <div class="a-form-field"
                         :class="{ 'a-input-group--error': $v.rows.$each[rowId].criteria.$each[item.id].value.$error}"
                         v-if="item.format.NUMBER">
                      <div class="a-col-block-content">
                        <div class="a-input-text-after-before">
                          <input-cost class="a-input a-input--w-100 u-margin-right-7"
                                      v-model="row.criteria[item.id].value"
                                      @blur="saveForm()"></input-cost>
                          <p>{{item.okei}}</p>
                        </div>
                        <p class="a-text-small" v-if="item.minValue || item.maxValue">
                          <span v-if="item.minValue" style="padding-right: 8px;">{{$t('form.tender.reduction.min-value')}} - {{item.minValue | price}}</span>
                          <span v-if="item.maxValue">{{$t('form.tender.reduction.max-value')}} - {{item.maxValue | price}}</span>
                        </p>
                      </div>
                    </div>
                  </template>

                  <template v-else>
                    <p class="text-nowrap" v-if="item.format.NUMBER">{{row.criteria[item.id].value | price}} {{item.okei}}</p>
                  </template>
                </td>

                <td :class="{'table-tab__background--green':isMyBidBest(row.position)}" v-if="canSeeLeaderBid">{{$t('form.lot.specs.mine')}}</td>
                <td class="text-nowrap" :class="{'table-tab__background--green':isMyBidBest(row.position)}">{{row.presentPrice | present-price}}</td>
                <td class="text-nowrap" :class="{'table-tab__background--green':isMyBidBest(row.position)}">{{totalPrice(row) | price}}</td>

                <td :class="{'table-tab__background--green':isMyBidBest(row.position)}"
                    v-for="item in lotPriceCriteria">
                  <p class="u-padding-bottom-12">{{item.criterionName}}:</p>

                  <template v-if="bid.permissions.CAN_EDIT_BID || (bid.isEditingForRetend && hasBidForPosition(row.position))">
                    <div class="a-col-block-content"
                         v-if="item.format.NUMBER">
                      <div class="a-input-text-after-before">
                        <input-cost class="a-input a-input--w-100 u-margin-right-7"
                                    v-model="row.criteria[item.id].value"
                                    @blur="saveForm()"></input-cost>
                        <p>{{$t(lot.currency.label)}}</p>
                      </div>
                      <p class="a-text-small" v-if="item.minValue || item.maxValue">
                        <span v-if="item.minValue" style="padding-right: 8px;">{{$t('form.tender.reduction.min-value')}} - {{item.minValue | price}}</span>
                        <span v-if="item.maxValue">{{$t('form.tender.reduction.max-value')}} - {{item.maxValue | price}}</span>
                      </p>
                    </div>

                    <dropdown-new class="select-w-140 u-margin-right-7"
                                  :placeholder="'form.tender.reduction.item-not-specified'"
                                  :options="item.values.map(e => ({ id: e.value, name: e.name}))"
                                  v-model="row.criteria[item.id].value"
                                  @change="saveForm()"
                                  v-else-if="item.format.CHOICE">
                    </dropdown-new>
                  </template>
                  <template v-else>
                    <p class="text-nowrap" :class="{'table-tab__color-information table-tab__background-red': row.price > 0 && row.criteria[item.id].value > row.price}">
                      {{row.criteria[item.id].value | price}}
                    </p>
                  </template>
                </td>

                <td :class="{'table-tab__background--green':isMyBidBest(row.position)}"
                    v-for="item in priceCriteria">
                  <p class="u-padding-bottom-12">{{item.criterionName}}:</p>

                  <template v-if="bid.permissions.CAN_EDIT_BID || (bid.isEditingForRetend && hasBidForPosition(row.position))">
                    <div class="a-form-field"
                         :class="{ 'a-input-group--error': $v.rows.$each[rowId].criteria.$each[item.id].value.$error}"
                         v-if="item.format.NUMBER">
                      <div class="a-col-block-content">
                        <div class="a-input-text-after-before">
                          <input-cost class="a-input a-input--w-100 u-margin-right-7"
                                      v-model="row.criteria[item.id].value"
                                      @blur="saveForm()"></input-cost>
                          <p>{{item.okei}}</p>
                        </div>
                        <p class="a-text-small" v-if="item.minValue || item.maxValue">
                          <span v-if="item.minValue" style="padding-right: 8px;">{{$t('form.tender.reduction.min-value')}} - {{item.minValue | price}}</span>
                          <span v-if="item.maxValue">{{$t('form.tender.reduction.max-value')}} - {{item.maxValue | price}}</span>
                        </p>
                      </div>
                    </div>

                    <div class="a-col-block-content" v-else-if="item.format.CHOICE">
                      <div class="a-input-text-after-before">
                        <dropdown-new class="select-w-140 u-margin-right-7"
                                      :placeholder="'form.tender.reduction.item-not-specified'"
                                      :options="item.values.map(e => ({ id: e.value, name: e.name}))"
                                      v-model="row.criteria[item.id].value"
                                      @change="saveForm()">
                        </dropdown-new>

                        <p class="text-nowrap" v-if="row.criteria[item.id].value !== undefined">{{row.criteria[item.id].value | price}} {{item.okei}}</p>
                      </div>
                    </div>
                  </template>

                  <template v-else>
                    <p class="text-nowrap" v-if="item.format.NUMBER">{{row.criteria[item.id].value | price}} {{item.okei}}</p>
                    <p class="text-nowrap" v-if="item.format.CHOICE">{{row.criteria[item.id].value | price}} {{item.okei}}</p>
                  </template>
                </td>
              </tr>

              <tr class="table-tab__tr border-bottom" v-if="canSeeLeaderBid">
                <td>{{$t('form.lot.specs.leader')}}</td>
                <td class="text-nowrap">{{leader[row.position].presentPrice | present-price}}</td>
                <td class="text-nowrap">{{leader[row.position].total | price}}</td>

                <td v-for="item in lotPriceCriteria">
                  <p class="u-padding-bottom-12">{{item.criterionName}}:</p>

                  <template>
                    <p class="text-nowrap" v-if="item.format.NUMBER">{{leader[row.position].criteria[item.num] | get('value') | price}}</p>
                    <p class="text-nowrap" v-if="item.format.CHOICE">{{leader[row.position].criteria[item.num] | get('value') | price}}</p>
                  </template>
                </td>

                <td v-for="item in priceCriteria">
                  <p class="u-padding-bottom-12">{{item.criterionName}}:</p>

                  <template>
                    <p class="text-nowrap"v-if="item.format.NUMBER">{{leader[row.position].criteria[item.num] | get('value') | price}}</p>
                    <p class="text-nowrap" v-if="item.format.CHOICE">{{leader[row.position].criteria[item.num] | get('value') | price}}</p>
                  </template>
                </td>
              </tr>
            </template>
          </tbody>
        </table>
      </div>
      <div class="table-tab__nav" v-if="0">
        <nav>
          <ul class="pagination">
            <li class="page-item prev"><a class="page-link" href="#"><img src="/img/static/arrow-next-prev.png" alt=""></a></li>
            <li class="page-item"><a class="page-link" href="#">1</a></li>
            <li class="page-item"><a class="page-link" href="#">2</a></li>
            <li class="page-item active"><a class="page-link" href="#">3</a></li>
            <li class="page-item"><a class="page-link" href="#">4</a></li>
            <li class="page-item"><a class="page-link" href="#">5</a></li>
            <li class="page-item"><a class="page-link" href="#">6</a></li>
            <li class="page-item"><a class="page-link" href="#">7</a></li>
            <li class="page-item disabled"><a class="page-link" href="#">...</a></li>
            <li class="page-item"><a class="page-link" href="#">10</a></li>
            <li class="page-item next"><a class="page-link" href="#"><img src="/img/static/arrow-next-prev.png" alt=""></a></li>
          </ul>
        </nav>
        <div class="admin-buy__show-item">
          <p>Отображать по </p>
          <div class="selectricWrapper select-w-77"><div class="selectricHideSelect"><select class="select-w-77">
            <option value="">10</option>
            <option>10</option>
            <option>10</option>
            <option>10</option>
            <option>10</option>
            <option>10</option>
            <option>10</option>
            <option>10</option>
            <option>10</option>
            <option>10</option>
            <option>10</option>
          </select></div><div class="selectric"><p class="label">10</p><b class="button"><img class="selectric-img-button" src="/img/static/vector-arrow.svg" alt=""></b></div><div class="selectricItems" tabindex="-1"><ul><li class="selected">10</li><li class="">10</li><li class="">10</li><li class="">10</li><li class="">10</li><li class="">10</li><li class="">10</li><li class="">10</li><li class="">10</li><li class="">10</li><li class=" last">10</li></ul></div><input type="text" class="selectricInput"></div>
        </div>
      </div>
    </div>
    </section>

    <template v-if="total">
      <div class="a-tab__title-block">
        <h3>{{$t('form.lot.total')}} </h3>
      </div>
      <div class="table-tab" style="max-width: 300px">
        <div class="table-tab__container">
          <table class="table-tab__block table table-short">
            <thead class="table-tab__thead">
            <tr>
              <th class="u-text-left">
                <span v-t="lot.currency.label"></span>
                <img class="table-tab__img-help" src="@/assets/img/static/info.svg" alt="">
              </th>
              <td>{{total | price}}</td>
            </tr>
            </thead>
          </table>
        </div>
      </div>
      <br>
    </template>
  </div>
</template>

<script>
  import CommonMixins from '../../mixins/common'
  import TemplateItem from "../../../../admin/catalogs/templates/TemplateItem";
  import ReductionSpecFilter from '@/api/types/reduction-spec-filter';
  import UploadTemplate from '@/components/purchases/upload-template'

  // вот сначала столбцы строятся type==Expert && typePosition=="Specification", потом
  // type==PriceLot потом type==Price && typePosition=="Specification"

  export default {
    components: {
      TemplateItem,
      UploadTemplate
    },

    props: {
      lot: {
        type: Object,
        required: true
      },

      bid: {
        type: Object,
        required: true
      }
    },

    mixins: [
      CommonMixins
    ],

    data: () => ({
      selectionMode: undefined,
      selection: {},
      method: undefined
    }),

    computed: {
      specs() {
        // needs to make Vue react or changes
        this.lot.request.ownBids;
        this.lot.request.best;

        if (this.method == ReductionSpecFilter.LEADER) {
          return this.bid.specs.filter(e => this.lot.request.leader[e.position].bid === this.bid.id);
        }
        else if (this.method == ReductionSpecFilter.NOT_LEADER) {
          return this.bid.specs.filter(e => this.lot.request.leader[e.position].bid !== this.bid.id);
        }
        else if (this.method == ReductionSpecFilter.MY_BID) {
          const positions = _.filter(this.lot.request.ownBids, { bid: this.bid.id }).map(e => e.position);
          return this.bid.specs.filter(e => _.includes(positions, e.position));
        }
        else if (this.method == ReductionSpecFilter.NO_MY_BID) {
          const positions = _.filter(this.lot.request.ownBids, { bid: this.bid.id }).map(e => e.position);
          return this.bid.specs.filter(e => !_.includes(positions, e.position));
        }

        return this.bid.specs;
      },

      expertCriteria() {
        return this.bid.criteria.expert.filter(e => e.unit.CATALOG);
      },

      reductionCriteria() {
        return this.bid.criteria.reduction.filter(e => e.unit.CATALOG);
      },

      reducedPriceCriteria() {
        return this.bid.criteria.reducedPrice;
      },

      lotPriceCriteria() {
        return this.bid.criteria.lotPrice;
      },

      priceCriteria() {
        return this.bid.criteria.price.filter(e => e.unit.CATALOG);
      },

      numberPriceCriteria() {
        return _.orderBy(this.priceCriteria.filter(e => e.format.NUMBER), 'num')
      },

      rows() {
        //return this.bid.specs;
        //return this.specs;

        if (!this.selectionMode) {
          return this.specs;
        }

        return this.specs.filter(s => {
          if (this.selectionMode === 'ShowCheck') {
            return !!this.selection[s.position];
          }
          else if (this.selectionMode === 'ShowUncheck') {
            return !this.selection[s.position];
          }
          else {
            return true;
          }
        })
      },

      total() {
        const v = this.rows.reduce((acc, row) => {
          const p = this.totalPrice(row) || 0;
          return acc + p;
        }, 0);

        return v;
      },

      leader() {
        return _.get(this.lot.request, 'leader');
      },

      canSeeLeaderBid() {
        return !!this.leader
      },

      reducedPriceWeight() {
        return _.get(this.lot.criteria.reducedPrice, '[0].weight');
      }
    },

    updated() {
      console.info('specification updated');
    },

    validations: {
      rows: {
        $each: {
          criteria: {
            $each: {
              value: {
                valid: (item, vm) => {
                  const min = +vm.minValue;
                  const max = +vm.maxValue;

                  if (!min && !max) return true;

                  return (vm.value >= min || !min) && (vm.value <= max || !max);
                }
              }
            }
          }
        }
      }
    },

    methods: {
      isMyBidBest(position) {
        return _.get(this.leader, `[${position}].bid`) === this.bid.id;
      },

      hasBidForPosition(position) {
        return !!_.find(this.lot.request.ownBids, { bid: this.bid.id, position: position });
      },

      totalPrice(row) {
        const crit = _.get(this.lotPriceCriteria, '[0]');

        if (crit) {
          return _.get(row, `criteria[${crit.id}].value`) * row.count;
        }
      },

      async onFileReady(file, options) {
        if (file instanceof File) {
          file = {
            file,
            sign: undefined
          }
        }

        this.runBlockerAction(async () => {
          try {
            await this.$store.dispatch('addFileToPublicLotCriterion', {
              requestId: this.lot.request.id,
              criterionId: options.criterionId,
              position: options.position,
              bidId: this.bid.num,
              file: file.file,
              sign: file.sign
            });
          }
          catch(e) {
            console.error('unable to attach file to criterion', e);
            this.globalErrorHandler(e);
          }
        })
      },

      async onRemoveFileClick(options) {
        this.runBlockerAction(async () => {
          try {
            await this.$store.dispatch('removeFileFromPublicLotCriterion', {
              requestId: this.lot.request.id,
              criterionId: options.criterionId,
              position: options.position,
              bidId: this.bid.num,
              fileId: options.fileId
            });
          }
          catch(e) {
            console.error('unable to attach file from criterion', e);
            this.globalErrorHandler(e);
          }
        })
      },

      onResetSelectionClick() {
        this.selectionMode = undefined;
        this.selection = {};
      },

      async onDownloadSpecificationTemplateClick() {
        this.runBlockerAction(async() => {
          try {
            await this.$store.dispatch('downloadBidSpecificationTemplate', {
              lotId: this.lot.id,
              requestId: this.lot.request.id,
              bidId: this.bid.id,
              selection: this.selection,
              selectionMode: this.selectionMode,
              method: this.method
            })
          }
          catch(e) {
            console.error('unable to download specification template', e);
            this.globalErrorHandler(e);
          }
        });
      },

      async uploadSpecificationTemplate(file) {
        this.runBlockerAction(async() => {
          try {
            const template = await this.$store.dispatch('uploadReductionBidSpecificationTemplate', {
              lotId: this.lot.id,
              requestId: this.lot.request.id,
              file,
              priceCriteria: this.numberPriceCriteria
            });
            this.$refs.configureTemplate.open(template);
          }
          catch(e) {
            console.error('unable to upload specification template', e);
            this.globalErrorHandler(e);
          }
        })
      },

      async completeSpecificationTemplate({ fields, template }) {
        this.runBlockerAction(async() => {
          let xls;

          try {
            xls = await this.$store.dispatch('completeReductionBidSpecificationTemplateUpload', {
              requestId: this.lot.request.id,
              fileId: template.fileId,
              fields
            });
          }
          catch (e) {
            console.error('unable to upload specification template', e);
            this.globalErrorHandler(e);
          }

          if (xls) {
            const lotPriceCriteria = this.lot.criteria.lotPrice;

            for(let spec of xls.specs) {
              const bidSpec = _.find(this.bid.specs, { position: spec.position});

              if (bidSpec && lotPriceCriteria.length > 0) {
                for (let criterion of lotPriceCriteria) {
                  bidSpec.criteria[criterion.id].value = spec.price;
                }
              }
            }

            for(let criterion of xls.criterions) {
              const bidCriterion = _.find(this.bid.criteria.price, { num: criterion.num});
              const bidSpec = _.find(this.bid.specs, { position: criterion.position});

              if (bidCriterion && bidSpec) {
                bidSpec.criteria[bidCriterion.id].value = criterion.value;
              }
            }

            this.saveForm();
          }
        });

        this.$refs.configureTemplate.close();
      },
    }
  }
</script>

<style scoped>

</style>
